module.exports = __webpack_public_path__ + "img/index-tj1.ef88fd78.png";